export const objectToCookiesString = (object: { [key: string]: string }): string => {
    let result = ''
    for (const key in object) {
        result = `${result}${key}=${object[key]};`
    }
    return result
}
